import { __ } from '@wordpress/i18n';
import { useState } from '@wordpress/element';
import {
  __experimentalToggleGroupControl as ToggleGroupControl,
  __experimentalToggleGroupControlOptionIcon as ToggleGroupControlOptionIcon,
  RangeControl,
} from '@wordpress/components';
import {arrowRight, arrowLeft, arrowUp, arrowDown} from '@wordpress/icons';
import { VayuBlocksDevice,VayuBlocksDeviceControl } from '@vayu-blocks/device-control';
import { HeightControl } from '@vayu-blocks';
import { SlideButton } from '@vayu-blocks/global';

export const VayuBlocksPositionPanel = ({ onChange, position }) => {
  const device = VayuBlocksDevice();
  const [firstDesktop, setFirstDesktop] = useState(false);
  const [firstTablet, setFirstTablet] = useState(false); 

  const updatePositionValue = (keyName, newValue) => {
    onChange(position?.key, {
      ...position?.value,
      [keyName]: newValue,
    });
  };

  const updateOffsetValue = (keyName, newValue) => {
    const attr = keyName;

		const updatedAttributes = {
		  ...position.value,
		  [keyName]: {
			  ...(position?.value?.[keyName] || {}), 
			  [device]: newValue,
		  },
		};

		const isFirstRun = attr?.[device] === undefined;
		const isTabletFirstRun = localStorage.getItem('firstTablet') || firstTablet;
  
		if (device === 'Desktop') {
		  if (isFirstRun || firstDesktop) {
			  Object.assign(updatedAttributes[keyName], { Tablet: newValue, Mobile: newValue });
			  localStorage.setItem('firstTablet', 'true');
			  setFirstTablet(true);
			  setFirstDesktop(true);
		  }
		} else if (device === 'Tablet') {
			if (isTabletFirstRun) {
				Object.assign(updatedAttributes[keyName], { Mobile: newValue});
				localStorage.removeItem('firstTablet');
				setFirstTablet(true);
				setFirstDesktop(false);
			}
		} else {
			setFirstTablet(false);
			setFirstDesktop(false);
		}
    
    onChange(position.key, updatedAttributes);
  };

  const renderOffsetControl = (direction, label) => {
    const offsetKey = `offset${direction}`;

    return (

          <HeightControl 
						label={<VayuBlocksDeviceControl label={__(label, 'vayu-blocks')}  />}
						onChange={(val) =>updateOffsetValue(offsetKey , val)}
						value={position.value?.[offsetKey]?.[device] || '0px'}
            minimumunit={{ px: -500, '%': 0 , em:-50 , rem: -50, vw:-100, vh: -100}}
					/>
    );
  };

  return (
    <>
    
      <SlideButton  
        button={{ inherit: "Default", absolute: "Absolute", fixed:"Fixed" }}
        onChange={(value) => updatePositionValue("value", value)}
        value={position?.value?.value || 'default'}
      /> 

      { (position.value?.value === 'absolute' || position.value?.value === 'fixed') && (
        <>
          <div  className='alignment-component-vb vb-toogle-icon-position vb-toggle-icon-width'>
            <ToggleGroupControl
              __next40pxDefaultSize={true}
              __nextHasNoMarginBottom={true}
              label={__('Horizontal Orientation', 'vayu-blocks')}
              onChange={(value) => updatePositionValue("horiori", value)}
              value={position?.value?.horiori}
               size="default"
              className="vb-toogle-icon-position-border "
              isDeselectable
            >
              <ToggleGroupControlOptionIcon icon={arrowLeft} label={__('Left', 'vayu-blocks')} value="left" />
              <ToggleGroupControlOptionIcon icon={arrowRight} label={__('Right', 'vayu-blocks')} value="right" />
            </ToggleGroupControl>
          </div>

          {position.value?.horiori === 'left' && renderOffsetControl('left', 'Left')}
          {position.value?.horiori === 'right' && renderOffsetControl('right', 'Right')}

          <br/>

          <div className="alignment-component-vb vb-toogle-icon-position vb-toggle-icon-width">
            <ToggleGroupControl
              __next40pxDefaultSize={true}
              __nextHasNoMarginBottom={true}
              label={__('Vertical Orientation', 'vayu-blocks')}
              onChange={(value) => updatePositionValue("vertiori", value)}
              className="vb-toogle-icon-position-border"
              value={position?.value?.vertiori}
            >
              <ToggleGroupControlOptionIcon icon={arrowUp} label={__('Top', 'vayu-blocks')} value="top" />
              <ToggleGroupControlOptionIcon icon={arrowDown} label={__('Bottom', 'vayu-blocks')} value="bottom" />
            </ToggleGroupControl>
          </div>

          {position.value?.vertiori === 'top' && renderOffsetControl('top', 'Top')}
          {position.value?.vertiori === 'bottom' && renderOffsetControl('bottom', 'Bottom')}
        </>
      )}

      <br/>

      <RangeControl
        label={<VayuBlocksDeviceControl label={__('z-index', 'vayu-blocks')}  />}
        value={ position.value?.zIndex?.[device] ?? 0}
        onChange={(value) => updateOffsetValue("zIndex", value)}
        step={ 1 }
        min={ -999999 }
        max={ 999999 }
        allowReset={ true }
      />
    </>
  );
};

/*
"position": {
  "type": "object",
  "default": {
    "value": "realative",
    "z-index": 0,
    "zIndex": {
      "Desktop": null,
      "Tablet": null,
      "Mobile": null
    },
    "hori-ori": "",
    "verti-ori": "",
    "horiori": "",
    "vertiori": "bottom",
    "offsetleft": {
      "Desktop": '',
      "Tablet": '',
      "Mobile": ''
    },
    "offsetright": {
      "Desktop": '',
      "Tablet": '',
      "Mobile": ''
    },
    "offsettop": {
      "Desktop": '',
      "Tablet": '',
      "Mobile": ''
    },
    "offsetbottom": {
      "Desktop": '',
      "Tablet": '',
      "Mobile": ''
    }
  }
}

*/